import { render, staticRenderFns } from "./ComplianceSign.vue?vue&type=template&id=40af9da2&scoped=true"
import script from "./ComplianceSign.vue?vue&type=script&lang=js"
export * from "./ComplianceSign.vue?vue&type=script&lang=js"
import style0 from "./ComplianceSign.vue?vue&type=style&index=0&id=40af9da2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40af9da2",
  null
  
)

export default component.exports